module.exports = __webpack_public_path__ + "assets/f9befdce015bdf26dc4043c4cbb550bd.png";